import BaseModel from '../core/BaseModel'
import {constants}  from '../services/constants'
//import moment from "moment-timezone";
export default class ReportRequestActivationProductSerialModel extends BaseModel {
    constructor() {
        super({ 
                name: "report_request_activation_product_serial",
                tableName: 'view_request_activation_product'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID',
                primaryKey: true,
                display: false,
            },
            fullname_text: {
                name: 'fullname_text',
                type: "String",
                label: 'Tên khách hàng',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var records = data.request_activation;
                    var fullname_text = "";
                    if (records){
                        if (records.customer_profile != undefined && records.customer_profile != null) {
                            fullname_text = records.customer_profile.full_name;
                            //this.phone_number = records.customer_profile.phone_number;
                            //this.phone_number = this.phone_number.replace('+84', '0');
                        }
                        if (records.customer_name != undefined && records.customer_name != null ) {
                            fullname_text = records.customer_name;
                        }
                    }
                    data.fullname_text = fullname_text;
                }
            },
            phone_text: {
                name: 'phone_text',
                type: "String",
                label: 'SĐT khách hàng',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var records = data.request_activation;
                    var text_data = "";
                    if (records){
                        if (records.customer_profile != undefined && records.customer_profile != null) {
                            text_data = records.customer_profile.phone_number;
                            text_data = text_data.replace('+84', '0');
                        }
                    }
                    data.phone_text = text_data;
                }
            },
            address_text: {
                name: 'address_text',
                type: "String",
                label: 'Địa chỉ khách hàng',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var text_data = "";
                    if (data.request_activation) {
                        if (data.request_activation.customer_profile){
                            text_data = constants.convertAddressCustomer(data.request_activation.customer_profile);
                        }
                    }
                    data.address_text = text_data;
                }
            },
            model_code: { 
                name: 'model_code', 
                type: "String", 
                label: 'Model',
                width: 13,
                sortable: false,
                computed: (data) => {
                    data.model_code = (data.product_serial_number !== undefined && data.product_serial_number !== null && data.product_serial_number.product !== undefined && data.product_serial_number.product !== null) ? data.product_serial_number.product.model_code  :  '';
                }
            },
            model_name: { 
                name: 'model_name', 
                type: "String", 
                label: 'Tên sản phẩm',
                width: 13,
                sortable: false,
                computed: (data) => {
                    data.model_name = (data.product_serial_number !== undefined && data.product_serial_number !== null && data.product_serial_number.product !== undefined && data.product_serial_number.product !== null) ? data.product_serial_number.product.name  :  '';
                }
            },
            category_text: {
                name: 'category_text',
                type: "String",
                label: 'Loại sản phẩm',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var text_data = "";
                    if (!constants.isEmpty(data.product_serial_number)){
                        if (!constants.isEmpty(data.product_serial_number.product)){
                            if (!constants.isEmpty(data.product_serial_number.product.categories)){
                                text_data =  (!constants.isEmpty(data.product_serial_number.product.categories.name)) ? data.product_serial_number.product.categories.name:'';
                            }
                        }
                    }
                    data.category_text = text_data;
                }
            },
            serial_number: { 
                name: 'serial_number', 
                type: "String", 
                label: 'Serial number',
                width: 13,
                sortable: false,
                computed: (data) => {
                    data.serial_number = (data.product_serial_number !== undefined && data.product_serial_number !== null) ? data.product_serial_number.serial_number  :  '';
                }
            },
                warranty_status_text: {
                    name: 'warranty_status_text',
                    type: "String",
                    label: 'Trạng thái bảo hành',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        data.warranty_status_text = constants.convertWarrantyStatus(data.warranty_status);
                    }
                },
            date_of_sale_text: {
                name: 'date_of_sale_text',
                type: "Date",
                label: 'Ngày bán',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var records = data.request_activation;
                    var date_of_sale_text = null;
                    if (records){
                       date_of_sale_text = records.date_of_sale;
                    }
                    data.date_of_sale_text = date_of_sale_text;
                }
            },
            activation_date: {
                name: 'activation_date', 
                type: "Date", 
                label: 'Ngày kích hoạt',
                width: 13,
                sortable: false
            },
                dynamic_form_tmp: {
                    name: 'dynamic_form_tmp',
                    type: "String",
                    label: 'dynamic_form_tmp',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        data.phone_organization_text = text_data;
                    }
                },
               /* some_bills_text: {
                name: 'some_bills_text',
                type: "String",
                label: 'Số hóa đơn',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var text_data = "";
                    if (data.request_activation) {
                        if (data.request_activation.product_serial_number_dynamic_form){
                            var dataDynamic = (data.request_activation.product_serial_number_dynamic_form.length > 0) ? data.request_activation.product_serial_number_dynamic_form[0]:[];
                            if (!constants.isEmpty(dataDynamic.data_dynamic_form) && Object.keys(dataDynamic.data_dynamic_form).length){
                                var forms = JSON.parse(dataDynamic.data_dynamic_form);
                                //console.log("formsformsforms:",forms)
                                if (forms && forms != null && Array.isArray(forms) && forms.length) {
                                    for (let index = 0; index < forms.length; index++) {
                                        const item = forms[index];
                                        if (item && item.fields && item.fields != null && Object.keys(item.fields).length) {
                                            //var dynamicName = item.fields.name;
                                            var dynamicValue = item.fields.value;
                                            var alias = item.fields.alias;
                                            if (!constants.isEmpty(alias)){
                                                if (alias =='so hoa don' || constants.SkipVN(alias) =='so hoa don' ){
                                                    text_data = dynamicValue;
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    data.some_bills_text = text_data;
                }
            },
            promotionn_code_text: {
                name: 'promotionn_code_text',
                type: "String",
                label: 'Mã khuyến mãi',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var text_data = "";
                    if (data.request_activation) {
                        if (data.request_activation.product_serial_number_dynamic_form){
                            var dataDynamic = (data.request_activation.product_serial_number_dynamic_form.length > 0) ? data.request_activation.product_serial_number_dynamic_form[0]:[];
                            if (!constants.isEmpty(dataDynamic.data_dynamic_form) && Object.keys(dataDynamic.data_dynamic_form).length){
                                var forms = JSON.parse(dataDynamic.data_dynamic_form);
                                //console.log("formsformsforms:",forms)
                                if (forms && forms != null && Array.isArray(forms) && forms.length) {
                                    for (let index = 0; index < forms.length; index++) {
                                        const item = forms[index];
                                        if (item && item.fields && item.fields != null && Object.keys(item.fields).length) {
                                            //var dynamicName = item.fields.name;
                                            var dynamicValue = item.fields.value;
                                            var alias = item.fields.alias;
                                            if (!constants.isEmpty(alias)){
                                                if (alias =='promotion code' || constants.SkipVN(alias) =='promotion code' ){
                                                    text_data = dynamicValue;
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    data.promotionn_code_text = text_data;
                }
            },*/
            date_verify_text: {
                name: 'date_verify_text',
                type: "Date",
                label: 'Ngày nghiệm thu',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var date_verify = null;
                    if (data.verify_status == 1){
                        date_verify = data.modified_date;
                    }
                    data.date_verify_text = date_verify;
                }
            },
            note_verify_text: {
                name: 'note_verify_text',
                type: "String",
                label: 'Ghi chú nghiệm thu',
                width: 13,
                sortable: false,
                computed: (data) => {
                    var text_data = "";
                    if (data.verify_status == 1){
                        text_data = (!constants.isEmpty(data.note_verify)) ? data.note_verify:'';
                    }
                    data.note_verify_text = text_data;
                }
            },
                date_not_tested_text: {
                    name: 'date_not_tested_text',
                    type: "Date",
                    label: 'Ngày không nghiệm thu',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var date_verify = null;
                        if (data.verify_status == 2){
                            date_verify = data.modified_date;
                        }
                        data.date_not_tested_text = date_verify;
                    }
                },
                reason_lable_text: {
                name: 'reason_lable_text',
                type: "String",
                label: 'Lý do không nghiệm thu',
                    width: 13,
                sortable: false,
                computed: (data) => {
                    var text_data = "";
                    if (data.verify_status == 2){
                        if (!constants.isEmpty(data.reason_lable)){
                            text_data = (!constants.isEmpty(data.reason_lable.reason_name)) ? data.reason_lable.reason_name:'';
                        }

                    }
                    data.reason_lable_text = text_data;
                }
            },
                note_not_tested_text: {
                    name: 'note_not_tested_text',
                    type: "String",
                    label: 'Lý do chi tiết không nghiệm thu',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (data.verify_status == 2){
                            text_data = (!constants.isEmpty(data.note_not_tested)) ? data.note_not_tested:'';
                        }
                        data.note_not_tested_text = text_data;
                    }
                },
                organization_text: {
                    name: 'organization_text',
                    type: "String",
                    label: 'Đơn vị thực hiện',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.request_activation)) {
                            if (!constants.isEmpty(data.request_activation.organizations)) {
                                text_data = (!constants.isEmpty(data.request_activation.organizations.name)) ? data.request_activation.organizations.name : '';
                            }
                        }
                        data.organization_text = text_data;
                    }
                },
                phone_organization_text: {
                    name: 'phone_organization_text',
                    type: "String",
                    label: 'SĐT đơn vị',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.request_activation)) {
                            if (!constants.isEmpty(data.request_activation.organizations)) {
                                var phone_number = (!constants.isEmpty(data.request_activation.organizations.phone_number)) ? data.request_activation.organizations.phone_number : '';
                                    text_data = (!constants.isEmpty(phone_number)) ? phone_number.replace('+84', '0'):'';
                            }
                        }
                        data.phone_organization_text = text_data;
                    }
                },
                province_organization_text: {
                    name: 'province_organization_text',
                    type: "String",
                    label: 'Tỉnh/TP của đơn vị',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (!constants.isEmpty(data.request_activation)) {
                            if (!constants.isEmpty(data.request_activation.organizations)) {
                                if (!constants.isEmpty(data.request_activation.organizations.provinces)) {
                                    text_data = (!constants.isEmpty(data.request_activation.organizations.provinces.name)) ? data.request_activation.organizations.provinces.name : '';
                                }
                            }
                        }
                        data.province_organization_text = text_data;
                    }
                },
                implementation_staff_text: {
                    name: 'implementation_staff_text',
                    type: "String",
                    label: 'Nhân viên thực hiện',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var text_data = "";
                        if (data.request_activation) {
                            if (data.request_activation.users){
                                text_data = (!constants.isEmpty(data.request_activation.users.full_name)) ? data.request_activation.users.full_name:'';
                            }
                        }
                        data.implementation_staff_text = text_data;
                    }
                },
            /*date_verify_text: {
                name: 'date_verify_text',
                type: "Date",
                label: 'Ngày nghiệm thu',
                sortable: false,
                computed: (data) => {
                    var date_verify = null;
                    if (!constants.isEmpty(data.product_serial_number)){
                        if (!constants.isEmpty(data.product_serial_number.product_serial_number_info)){
                            if (data.product_serial_number.product_serial_number_info.verify_status == 1){
                                date_verify = data.product_serial_number.product_serial_number_info.activation_date;
                            }
                        }
                    }
                    data.date_verify_text = date_verify;
                }
            },*/
            /*verify_status: {
                name: 'verify_status', 
                type: "Selection",
                label: 'Trạng thái nghiệm thu',
                dataType: 'Label', 
                filter: { type: 'select', visible: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                options: [{ value: 1, label: 'Đã nghiệm thu'}, { value: 0, label: 'Chờ nghiệm thu'}, { value: 2, label: 'Không nghiệm thu'}],
                sortable: true,
            },*/
            // warranty_status: { 
            //     name: 'warranty_status', 
            //     type: "Selection",
            //     label: 'Trạng thái bảo hành',
            //     dataType: 'Label', 
            //     options: [{ value: 1, label: 'Đã kích hoạt'}, { value: 0, label: 'Chưa kích hoạt'}, { value: 2, label: 'Chờ kích hoạt'}, { value: 3, label: 'Đã kích hoạt'}, { value: 4, label: 'Hết bảo hành'}, {value: 6, label: 'Sản phẩm huỷ'}],
            //     filter: { type: 'select', visible: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
            //     sortable: true
            // },
            fied_detail: {
                refs: '  id modified_date request_activation_id serial_number_id activation_date verify_status warranty_status product_serial_number { id serial_number product { id model_code name warranty_time warranty_unit is_maintenance type_maintenance categories { name } } warranty_status product_serial_number_info { customer_profile_id organization_id warranty_status verify_status warranty_time warranty_unit activation_date } } request_activation { id users{ full_name } organizations { name provinces { id name } phone_number  } customer_type customer_name  status customer_profile { address province { id name } district { id name } ward { id name } full_name phone_number  user { user_type } } invoice_images date_of_sale product_serial_number_dynamic_form { id data_dynamic_form }  }  ',
                display: false
            }
        },)
    }

}